import { supabase } from "../services/supabase";
import { Produto } from "../types/database";

export const produtosRepository = {
  async buscarTodos(): Promise<Produto[]> {
    const { data, error } = await supabase
      .from("produtos")
      .select("*")
      .eq("ativo", true)
      .order("nome", { ascending: true });

    if (error) {
      console.error("Erro ao buscar produtos:", error);
      throw new Error(error.message);
    }

    return data ?? [];
  },

  async buscarTodosGerenciamento(): Promise<Produto[]> {
    const { data, error } = await supabase
      .from("produtos")
      .select("*")
      .order("nome", { ascending: true });

    if (error) {
      console.error("Erro ao buscar produtos para gerenciamento:", error);
      throw new Error(error.message);
    }

    return data ?? [];
  },

  async criarProduto(nome: string, preco: number): Promise<Produto> {
    const { data, error } = await supabase
      .from("produtos")
      .insert({
        nome: nome.trim(),
        preco,
        ativo: true,
      })
      .select()
      .single();

    if (error || !data) {
      console.error("Erro ao criar produto:", error);
      throw new Error(error?.message ?? "Erro ao criar produto");
    }

    return data;
  },

  async atualizarProduto(
    id: string,
    dados: Partial<Produto>,
  ): Promise<Produto> {
    const payload: Partial<Produto> = {};

    if (dados.nome !== undefined) payload.nome = dados.nome.trim();
    if (dados.preco !== undefined) payload.preco = dados.preco;
    if (dados.ativo !== undefined) payload.ativo = dados.ativo;

    const { data, error } = await supabase
      .from("produtos")
      .update(payload)
      .eq("id", id)
      .select()
      .single();

    if (error || !data) {
      console.error("Erro ao atualizar produto:", error);
      throw new Error(error?.message ?? "Erro ao atualizar produto");
    }

    return data;
  },
};
